import apiSlice from 'renderer/shared/state/apiSlice';
import {
  AuthResponseSchema,
  LoginRequest,
  LoginResponse,
  RegisterRequest,
  RegisterResponse,
  RegisterResponseSchema,
  ResetPasswordRequest,
  ResetPasswordResponse,
  ResetPasswordResponseSchema,
} from '../schemas/auth.schemas';
import { setCredentials } from '../state/userSlice';
import { setTokens } from '../state/authSlice';

const extendedApi = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    // Register
    register: builder.mutation<RegisterResponse, RegisterRequest>({
      query: (credentials) => ({
        url: '/auth/register',
        method: 'POST',
        body: credentials,
      }),
      extraOptions: { responseSchema: RegisterResponseSchema },
    }),
    // Login
    login: builder.mutation<LoginResponse, LoginRequest>({
      query: (user) => ({
        url: '/auth/login',
        method: 'POST',
        body: user,
      }),
      extraOptions: { responseSchema: AuthResponseSchema },
      onQueryStarted: async (arg, { queryFulfilled, dispatch }) => {
        console.log('onQueryStarted');
        try {
          const { data } = await queryFulfilled;
          console.log('data', data);
          if (data.user) {
            dispatch(setCredentials(data));
          }
          if (data.tokens) {
            dispatch(setTokens(data));
          }
        } catch (error) {
          console.log('error', error);
          // return { error };
        }
      },
    }),
    sendCode: builder.mutation<
      void,
      { username: string; password: string; phone: string }
    >({
      query: (credentials) => ({
        url: '/auth/send-code',
        method: 'POST',
        body: credentials,
      }),
    }),
    resetPassword: builder.mutation<
      ResetPasswordResponse,
      ResetPasswordRequest
    >({
      query: (body) => ({
        url: '/auth/forgot-password',
        method: 'POST',
        body,
      }),
      extraOptions: {
        responseSchema: ResetPasswordResponseSchema,
      },
    }),
  }),
});

export const {
  useLoginMutation,
  useSendCodeMutation,
  useRegisterMutation,
  useResetPasswordMutation,
} = extendedApi;
